import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

type Props = {
  label: React.ReactNode | undefined;
  value?: unknown;
  options: string[];
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function TextAutocomplete(props: Props) {
  const { label, value, validateIsNotEmpty = false, options, handleChange, handleBlur } = props;

  return (
    <Autocomplete
      value={value}
      options={options}
      fullWidth
      freeSolo
      renderInput={(params) => (
        <TextField
          variant='standard'
          required={validateIsNotEmpty || false}
          label={label}
          onChange={(event) => handleChange(event.target.value)}
          onBlur={(event) => {
            if (handleBlur !== null && handleBlur !== undefined) {
              handleBlur(event.target.value);
            }
          }}
          {...params}
        />
      )}
      onChange={(_, value) => {
        handleChange(value);
      }}
    />
  );
}

export type { Props as TextFieldProps };

export default TextAutocomplete;
